import { Form, Spin, Input, Checkbox } from "antd";
import { Button as PrimeBtn } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, {useEffect, useRef, useState } from "react";

import {
    addNewCompany
} from "../../../../apis/CompanyApis";

const AddCompanyDialog = (props) => {
    const [apiLoading, setApiLoading] = useState(false);
    const toast = useRef(null);
    const [form] = Form.useForm();
    const [formData, setFormData] = useState({
        reportImage2D: false,
        reportImage3D: false,
        reportImage3D_2: false,
      });

    useEffect(()=>{
        form.validateFields.companyName = "";
    });

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            setApiLoading(true);
            addNewCompany({name: values.companyName, ... formData}).then((res) => {
                if (res.status === 200) {
                    toast.current.show({
                        severity: "success",
                        summary: "Status",
                        detail: "Add company successfully",
                        life: 3000
                    })
                    
                    setApiLoading(false);
                    props.setVisible(false);
                } else {
                    toast.current.show({
                        severity: "warn",
                        summary: "Status",
                        detail: "Add company failed!",
                        life: 3000
                    })
                    setApiLoading(false);
                    props.setVisible(false);
                }
            }).catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
        })
    }

    const handleCheckboxChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.checked,
        });
      };
   
    return (
        <React.Fragment>
            <Toast ref={toast} />
            <Dialog
                style={{ width: "480px" }}
                header={"Add company"}
                visible={props.visible}
                onHide={() => { props.setVisible(false) }}
            >
                <Spin spinning={apiLoading} >
                    <React.Fragment>
                        <div className='flex justify-content-between align-items-center'>
                            <Form form={form} onFinish={handleSubmit}>
                                <Form.Item required={false}
                                    name="companyName" label="Name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter company name",
                                        },
                                    ]}
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}>
                                    <Input
                                        style={{ width: "270px" }}
                                        onKeyDown={(e) => e.stopPropagation()}
                                    />
                                </Form.Item>

                                <Form.Item required={false}
                                    name="Plans included" label="Plans Included"
                                    labelCol={{ span: 9 }}
                                    labelAlign={"left"}>
                                    <Checkbox
                                        name="reportImage2D"
                                        onChange={handleCheckboxChange}
                                        checked={formData.reportImage2D}
                                    >
                                        2D
                                    </Checkbox>
                                    <Checkbox
                                        name="reportImage3D"
                                        onChange={handleCheckboxChange}
                                        checked={formData.reportImage3D}
                                    >
                                        3D _1
                                    </Checkbox>
                                    <Checkbox
                                        name="reportImage3D_2"
                                        onChange={handleCheckboxChange}
                                        checked={formData.reportImage3D_2}
                                    >
                                        3D _2
                                    </Checkbox>

                                </Form.Item>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <PrimeBtn
                                        style={{
                                            backgroundColor: "#037eea",
                                            borderColor: "#037eea",
                                            float: "right",
                                            marginRight: "1rem",
                                        }}
                                        type="submit"
                                        label="Submit"
                                    />
                                </div>
                            </Form>
                        </div>
                    </React.Fragment>
                </Spin>

            </Dialog>
        </React.Fragment>
    )
}

export default AddCompanyDialog
